import { PayloadObject } from '@utiqLoader/types';
import { utiqMachine } from '.';
import { acceptConsent, checkEligibility, denyConsent } from './actions';

/**
These actions are used to trigger behaviour when one is OUTSIDE the machine
*/

type EligibilityTrigger = 'consent_granted' | 'load';
export async function triggerEligibilityCheck(input: {
  trigger: EligibilityTrigger;
  isConsentGranted?: boolean;
  hasConsentChanged?: boolean;
  ignoreInterval?: boolean;
}) {
  function shouldSendRequest() {
    const snap = utiqMachine.makeSnap();
    if (
      input.trigger === 'consent_granted' &&
      input.isConsentGranted === true &&
      input.hasConsentChanged === false &&
      snap.localStorage.utiqEligibility?.isEligible !== false
    ) {
      return false;
    }

    if (window.Utiq?.syncVersionCookies) {
      return true;
    }

    if (snap.localStorage.utiqEligibility === null) {
      return true;
    }

    if (
      typeof snap.localStorage.utiqEligibility?.retryEligibilityCheckTime ===
        'number' &&
      snap.localStorage.utiqEligibility.retryEligibilityCheckTime <
        snap.now.getTime()
    ) {
      return true;
    }

    if (
      'isConsentGranted' in input &&
      input?.isConsentGranted === true &&
      utiqMachine.makeSnap().cookies.utiq_consent_status !== 'true'
    ) {
      return true;
    }

    if (input.ignoreInterval) {
      return true;
    }

    return false;
  }

  while (
    utiqMachine.ctx.axios.active.find(
      (x) => x.req.url?.includes('mno-precheck'),
    )
  ) {
    await new Promise((done) => setTimeout(done, 1));
  }

  if (shouldSendRequest()) {
    checkEligibility(
      input.trigger,
      utiqMachine.makeSnap(),
      utiqMachine.ctx.config,
      utiqMachine.ctx.axios.instance,
    );
  }

  await utiqMachine.run();

  while (
    utiqMachine.ctx.axios.active.find(
      (x) => x.req.url?.includes('mno-precheck'),
    )
  ) {
    await new Promise((done) => setTimeout(done, 1));
  }

  const isEligible =
    utiqMachine.makeSnap().localStorage.utiqEligibility?.isEligible ?? false;

  return isEligible;
}

export async function triggerConsentChange(
  isConsentGranted: boolean,
  payload: PayloadObject,
) {
  const templateData = window.Utiq?.data?.popupContent;

  utiqMachine.ctx.consentPayload = payload;

  if (isConsentGranted) {
    acceptConsent(utiqMachine.makeSnap(), utiqMachine.ctx, templateData!);
  } else {
    denyConsent(utiqMachine.makeSnap(), utiqMachine.ctx);
  }

  await utiqMachine.run();

  if (utiqMachine.ctx.window.Utiq?.isInitialPageLoad) {
    utiqMachine.ctx.window.Utiq.isInitialPageLoad = false;
  }
}
